export default "__VITE_ASSET__CJ8q2HUe__"